import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGumtreeComponent } from './simple-icons-gumtree.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGumtreeComponent ],
    exports:      [ SimpleIconsGumtreeComponent ],
    bootstrap:    []
})
export class SimpleIconsGumtreeModule {}
